<div class="ng-hide meganav__overlay"
     [toggleClass]="'is-meganav-open'"
     [toggleClassBy]="meganavToggleGroupId"></div>
